<template>
  <nav id="top_nar" class="top-nar navbar navbar-expand-lg navbar-dark default-color">
    <div class="container">
      <div class="menu-wrapper">
        <ul class="navbar-nav mr-auto nav-flex-icons">
          <li class="nav-item avatar">
            <avatar :channel-id="me.channel_id"></avatar>
          </li>
          <li class="nav-item contact-name">
            <div class="member-name-side">
              <div class="nav-link user_name name-wrap">
                <span>{{ me.name }}</span>
                <img class="channel-img" :src="me.channel_image" v-if="me.channel_image">
                <span v-if="me.channel_image && me.channel_id">&nbsp;{{ me.channel_id }}</span>
              </div>
              <div class="tags-list-wrap">
                <a v-for="tag in me.tags" :key="tag.term_id" @click.prevent="handleCopy(tag.name)" class="badge badge-light">{{ tag.name }}</a>
              </div>
            </div>

            <a @click="showEditPanel"><mdb-icon icon="pen" v-if="showEditBtn"/></a>
            <a @click="markMember"><mdb-icon icon="thumbtack" :class="marked ? 'grey-text' : ''" v-if="showEditBtn"/></a>
            <div class="ml-2">
              <div v-if="loading" class="spinner-border text-light" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </li>
          <li class="nav-item"></li>
        </ul>
        <ul class="navbar-nav ml-auto nav-flex-icons">
          <li class="nav-item" v-if="!showEditBtn">
            <router-link class="nav-link" :to="{name:'add'}">
              <mdb-icon icon="user-plus"/>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link tag="span" class="nav-link" to="/">
              <mdb-icon far icon="address-book"/>
            </router-link>
          </li>
          <li class="nav-item" v-if="!showEditBtn">
            <router-link class="nav-link" :to="{name:'me'}">
              <mdb-icon icon="cog"/>
            </router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" @click="logout">
              <mdb-icon icon="sign-out-alt"/>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <edit-member @close="hideEditPanel" @update="handleMemberSave" :member="me" :show="showEditMember"></edit-member>
    <transition name="fade">
      <div v-if="toastText.length > 0" class="mini-toast z-depth-2" :class="toastClass">{{toastText}}</div>
    </transition>
  </nav>
</template>
<script>
import Avatar from "./avatar.vue";
import mdbIcon from "mdbvue/src/components/Content/Fa";
import editMember from "../components/EditMember";
import userService from "../Services/UserService";
import bookmarkService from "../Services/BookMark";
import copy from 'copy-to-clipboard';
const {EventBus} = require("../Bus.js");
let user = new userService();

export default {
  data() {
    return {
      loading: false,
      showEditMember: false,
      me: {
        name: '',
        channel_id: '',
        channel_img: '',
        tags: [],
      },
      uid: 0,
      marked: false,
      toastText: "",
      toastClass: "",
    };
  },

  components: {
    mdbIcon,
    editMember,
    Avatar
  },

  watch: {
    $route: {
      handler(to) {
        this.fetch()
          .then(() => {
            if (this.showEditBtn && !this.isMobileView) {
              this.showEditMember = true;
            }
          });
      },
      deep: true
    },
    showEditBtn(val) {
      if (!val) {
        this.showEditMember = val;
      }
    }
  },

  computed: {
    showEditBtn() {
      return this.uid > 0;
    },
    isMobileView() {
      return window.innerWidth < 1024;
    },
  },

  mounted() {
    this.fetch();
    EventBus.onProfileUpdated(this.fetch)
  },

  beforeDestroy() {
    EventBus.offProfileUpdated(this.fetch);
  },

  methods: {
    fetch() {
      this.loading = true;
      this.uid = parseInt(this.$route.params?.uid || 0) || 0;
      if (this.uid > 0) {
        return user.getUser(this.uid).then((data) => {
          this.me = data;
          this.fetchMarkState();
        })
        .finally(() => {
          this.loading = false;
        })
      } else {
        return user.me().then((data) => {
          const name = data.name;
          this.me = {...data};
          this.me.name = `${name} (Me)`;
          this.me.channel_id = `${data.channel_id || data.uid}`;
          this.fetchMarkState();
        })
        .finally(() => {
          this.loading = false;
        })
      }
    },

    logout() {
      if (confirm("Are you sure?")) {
        user.logout().finally(() => {
          window.location.reload();
        });
      }
    },

    showEditPanel() {
      this.showEditMember = true;
    },

    hideEditPanel() {
      this.showEditMember = false;
    },

    handleMemberSave(member) {
      this.me = {...member};
    },

    fetchMarkState() {
      const contact = bookmarkService.getContact(this.uid);
      if (this.uid > 0 && !!(contact)) {
        this.marked = true;
        return;
      }

      this.marked = false;
    },

    handleCopy(text) {
      if (copy(text)) {
        this.showToast("Copied!")
      } else {
        this.showToast("Copy failed!", 3000, "error")
      }
    },

    showToast(text, timeout = 1000, className = "") {
      this.toastText = text;
      this.toastClass = className;
      setTimeout(() => {
        this.toastText = "";
        this.toastClass = "";
      }, timeout);
    },

    markMember() {
      if (!this.marked && this.uid > 0) {
        bookmarkService.push(this.me);
        this.fetchMarkState();
      }
    }
  }
};
</script>

<style lang="scss">
@media (max-width: 768px) {
  .navbar {
    div.menu-wrapper {
      width: 100%;
      padding: 0;
    }
  }
}

.navbar {
  .fas {
    cursor: pointer;
    color: white;
  }

  & > div.container {
    justify-content: center;
  }

  .menu-wrapper {
    width: 83.333333%;
    justify-content: center;
    align-items: center;
    display: flex;
    padding: 0 1.25rem;
  }

  .contact-name > a {
    margin-left: 1em;

    &:last-child {
      margin-right: 0.5em;
    }
  }
}

.navbar .nav-item .nav-link.user_name {
  display: inline-block;
}
.top-nar {
  .member-name-side {
    padding-left: 0.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .tags-list-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5em;

    .badge {
      opacity: 0.7;
    }
  }

  .mini-toast {
    display: inline-block;
    position: fixed;
    left: 50%;
    top: 10vh;
    transform: translateX(-50%);
    padding: 0.5em 1em;
    border-radius: 0.5em;
    opacity: 0.9;
    z-index: 1000;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(0, 0, 0, 0.2);

    &.success {
      background-color: #2bbbad;
      border: 1px solid rgba(0, 255, 0, 0.2);
    }

    &.error {
      background-color: rgba(255, 0, 0, 0.9);
      border: 1px solid rgba(255, 0, 0, 0.2);
    }
  }

  //fade
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.25s;
  }
  .fade-enter{
    opacity: 0;
    transform: translate(-50%, -1em);
  }
  .fade-leave-to {
    opacity: 0;
    transform: translateX(-50%);
  }
}
</style>
